export default __webpack_public_path__ + "static/media/i_info_primaryDark.a91d490b.svg";